import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
//import Home from './views/HomeChristmas.vue'
//import HomeDesign from './views/HomeDesign.vue'

import History from './views/History.vue'
import Orario from './views/Orario.vue'
import Hardware from './views/Hardware.vue'
import Service from './views/Service.vue'
import Software from './views/Software.vue'
import Assistance from './views/Assistance.vue'
import SoftwareShowcase from './views/SoftwareShowcase.vue'
import WorkWithUs from './views/WorkWithUs.vue'
import Brand from './views/Brand.vue'
import Privacy from './views/Privacy.vue'
import Contact from './views/Contact.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { transition: 'fade', title: "Innovare per realizzare il futuro - page93 s.r.l." },
    },
    {
      path: '/history',
      name: 'history',
      component: History,
      meta: { transition: 'fade-in-up', title: "1993 ieri, oggi e domani - Storia - page93 s.r.l." },
    },
    {
      path: '/hardware',
      name: 'hardware',
      component: Hardware,
      meta: { transition: 'fade-in-right', title: "Hardware - page93 s.r.l." },
    },
    {
      path: '/service',
      name: 'service',
      component: Service,
      meta: { transition: 'fade-in-right', title: "Service - page93 s.r.l." },
    },
    {
      path: '/software',
      name: 'software',
      component: Software,
      meta: { transition: 'fade-in-right', title: "Software - page93 s.r.l." },
    },
    {
      path: '/showcase',
      name: 'softwareShowcaseNoParam',
      component: SoftwareShowcase,
      meta: { transition: 'fade-in-up', title: "Soluzioni gestionali per le imprese - page93 s.r.l." },
    },
    {
      path: '/showcase/:appName',
      name: 'softwareShowcase',
      component: SoftwareShowcase,
      meta: { transition: 'fade-in-up', title: "Soluzioni gestionali per le imprese - page93 s.r.l." },
    },
    {
      path: '/assistance',
      name: 'Assistance',
      component: Assistance,
      meta: { transition: 'fade-in-up', title: "Teleassistenza - page93 s.r.l." },
    },
    {
      path: '/lavoraconnoi',
      name: 'Lavora con noi',
      component: WorkWithUs,
      meta: { transition: 'fade-in-up', title: "Lavora con noi - page93 s.r.l." },
    },
    {
      path: '/brand',
      name: 'Brand',
      component: Brand,
      meta: { transition: 'fade-in-up', title: "Brand & Mission - page93 s.r.l." },
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      meta: { transition: 'fade-in-up', title: "Privacy - page93 s.r.l." },
    },
    {
      path: '/info',
      name: 'Contattaci',
      component: Contact,
      meta: { transition: 'fade-in-up', title: "Contattaci - page93 s.r.l." },
    },
    {
      path: '/orario',
      name: 'Orario',
      component: Orario,
      meta: { transition: 'fade-in-up', title: "Orario - page93 s.r.l." },
    }
  //*/
    /*{
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.

      // webpackChunkName: "about"
      component: () => import('./views/About.vue')
    }*/
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router